import { createAction, props } from '@ngrx/store';
import { FaqGroup } from '../models/faq-group';

export const loadFaqStores = createAction('[FaqStore] Load FaqStores');

export const loadFaqStoresSuccess = createAction(
    '[FaqStore] Load FaqStores Success',
    props<{ data: FaqGroup[] }>()
);

export const setFilterValue = createAction(
    '[FaqStore] Set Filter Value',
    props<{ data: string }>()
);
